module.exports = [
  { code: 'North Island', name: 'North Island' },
  { code: 'South Island', name: 'South Island' },
  { code: 'Stewart Island', name: 'Stewart Island' },
  { code: 'Chatham Islands', name: 'Chatham Islands' },
];
